import { GameEngine } from '../game/engine';
import type { Direction } from '../game/state';
export class AttractMode {
  readonly engine=new GameEngine();
  private next=0;
  constructor(){this.engine.start(3,true);}
  step():void{
    const e=this.engine;
    if(e.state==='GAME_OVER'||e.frame>1800){e.start(3,true);this.next=0;}
    if(e.state==='PLAYING'&&!e.frog.hop&&e.frame>=this.next){
      this.next=e.frame+12;
      const directions:(Direction|null)[]=['up','left','right',null,'down'];
      let best:Direction|null=null,bestScore=-Infinity;
      for(const direction of directions){
        const copy=e.clone();if(direction)copy.input(direction);
        for(let i=0;i<12;i++)copy.step();
        if(copy.state==='FROG_DYING'||copy.state==='GAME_OVER')continue;
        const target=copy.homes.filter(h=>!h.occupied).sort((a,b)=>Math.abs(a.x-copy.frog.x)-Math.abs(b.x-copy.frog.x))[0];
        let value=(232-copy.frog.y)*2+(copy.score-e.score)*4-(target?Math.abs(target.x-copy.frog.x)*0.1:0);
        if(direction==='up')value+=2;if(direction==='down')value-=4;
        // Look ahead one hop so the real engine catches impending traffic.
        if(copy.state==='PLAYING'){
          const trial=copy.clone();trial.input('up');for(let i=0;i<10;i++)trial.step();
          if(trial.state!=='FROG_DYING')value+=5;
        }
        if(value>bestScore){bestScore=value;best=direction;}
      }
      if(best)e.input(best);
    }
    e.step();
  }
}
